<div class="container-fluid">
  <!-- <div class="header-container">
    <div class="page-header">
      {{ 'bikeshop.shop_setup.header.rentals' | translate }} -> {{
      "bikeshop.shop_setup.card_headers._rental_products_and_accessories" | translate }}
    </div>
  </div> -->
  <div class="hubtiger-tab-container">
    <div (click)="selectedTab = 0" [ngClass]="{'selected' : selectedTab === 0}">{{ 'bikeshop.rentals.categories.rental_product_categories' | translate }}</div>
    <div (click)="selectedTab = 1" [ngClass]="{'selected' : selectedTab === 1}">{{ 'bikeshop.rentals.categories.rental_accessory_categories' | translate }}</div>
  </div>
</div>

<div class="product-container"><div [ngClass]="{'selected' : selectedTab === 0, 'unselected': selectedTab !== 0}"><app-rental-product-categories [messageService]="messageService"></app-rental-product-categories></div></div>
<div class="product-container"><div [ngClass]="{'selected' : selectedTab === 1, 'unselected': selectedTab !== 1}"><app-rental-accessory-categories  [messageService]="messageService"></app-rental-accessory-categories></div></div>

<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>